<script setup lang="ts">
import { computed } from 'vue'
import { useDonorPlan } from '@/composables/useDonorPlan'
import { useUpgradeModal } from '@/composables/useUpgradeModal'
import { useDonorFinancialYears } from '@/composables/useDonorFinancialYears'
import ApiErrorNotification from '@/components/generic/ApiErrorNotification.vue'
import DashboardDataLoading from '@/components/dashboard/ui/DashboardDataLoading.vue'
import GivingRecordPaywall from '@/components/dashboard/giving/GivingRecordPaywall.vue'
import GivingRecordPaid from '@/components/dashboard/giving/GivingRecordPaid.vue'

const { canViewGivingRecord, isPlanKnown } = useDonorPlan()
const { openUpgradeModal } = useUpgradeModal()

const { sortedYears, isReady, isLoading, apiError } = useDonorFinancialYears()

const showPaywall = computed(() => isPlanKnown.value && !canViewGivingRecord.value)
const showPaidRecord = computed(() => isPlanKnown.value && canViewGivingRecord.value)
const showLoading = computed(
  () =>
    !isPlanKnown.value ||
    (showPaidRecord.value && (isLoading.value || !isReady.value))
)
</script>

<template>
  <div>
    <ApiErrorNotification
      v-if="apiError"
      link="Donations"
      aria-label="Donations API error"
    >
      An error has occurred while fetching donations, please
      <strong>try again</strong>
      .
    </ApiErrorNotification>
    <DashboardDataLoading v-else-if="showLoading" />
    <template v-else>
      <div v-if="showPaywall" class="sa-stack-wide">
        <GivingRecordPaywall @upgrade="openUpgradeModal" />
      </div>
      <GivingRecordPaid
        v-else-if="showPaidRecord"
        :sorted-years="sortedYears"
        :is-loading="false"
      />
    </template>
  </div>
</template>
